<xui-dashboard-tile
  class="tile"
  [titleShadow]="true"
  [title]="translations.DASHBOARD.NEWS.TITLE | translate"
>
  <xui-article-carousel class="news" [articles]="news$ | async"></xui-article-carousel>
</xui-dashboard-tile>
